import type { Ref, InjectionKey, ComputedRef } from 'vue'

export interface UploadContext {
  accept: ComputedRef<string> | Ref<string>
}

export const UploadContextKey: InjectionKey<UploadContext> = Symbol('UploadContextKey')
